import type {
  TrendingData,
  TrendingDataPoint,
} from '@empathybroker/tsclient-stats/dist/models/trendingreport/trendingdata'
import { KpiEnum } from '../../enums/kpi.enum'

export function getKpiTrendingCount(kpi: KpiEnum, data: TrendingData['totals']): number {
  const kpiTotalKeys: Record<string, keyof TrendingData['totals']> = {
    [KpiEnum.QUERIES]: 'queryCount',
    [KpiEnum.CLICKS]: 'clickCount',
    [KpiEnum.NO_RESULTS]: 'noResultsCount',
    [KpiEnum.ADD2CART]: 'add2cartCount',
  }

  const key = kpiTotalKeys[kpi]

  return data[key] ?? 0
}

export function getKpiTrendingData(
  kpi: KpiEnum,
  data: Omit<TrendingData, 'totals'>,
): Array<TrendingDataPoint> {
  const tendingDataKeys: Record<string, keyof Omit<TrendingData, 'totals'>> = {
    [KpiEnum.QUERIES]: 'queries',
    [KpiEnum.CLICKS]: 'clicks',
    [KpiEnum.NO_RESULTS]: 'no_results',
    [KpiEnum.ADD2CART]: 'add2carts',
  }

  const key = tendingDataKeys[kpi]

  return data[key] ?? []
}
